/* app/js/src/components/dynamic-promo/dynamic-promo-create-edit.scss */
.cursor-pointer {
  cursor: pointer;
}
.edit-graphics-container::-webkit-scrollbar {
  height: 11px;
  overflow: visible;
  width: 11px;
  opacity: 1;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.edit-graphics-container::-webkit-scrollbar-button {
  height: 0;
  width: 0;
}
.edit-graphics-container::-webkit-scrollbar-corner {
  background: transparent;
}
.edit-graphics-container::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.edit-graphics-container::-webkit-scrollbar-thumb {
  background-color: #e3e6ea;
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
  min-height: 28px;
  padding: 100px 0 0;
  border-radius: 10px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.edit-graphics-container::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.edit-graphics-container::-webkit-scrollbar-track:hover {
  background-color: #eef2f6;
}
.edit-graphics-container::-webkit-scrollbar-track {
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
}
.input-group input[type=text] {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  border-radius: 4px;
  background-color: #ffffff;
  height: 30px;
  border: 1px solid #e1e6eb;
  line-height: 2.2em;
  font-size: 0.9em;
  padding: 0 15px;
  color: #232f3a;
}
.input-group input[type=text]:focus {
  border: 1px solid #aee5ff;
  outline: none;
}
.input-group input[type=text]::-webkit-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
.input-group input[type=text]:-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
.input-group input[type=text]::-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
.input-group input[type=text]:-ms-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
.input-group input.ng-invalid.ng-dirty[type=text],
.input-group input.ng-invalid.ng-touched[type=text] {
  border-color: #ef5350;
}
.btn-export {
  display: inline-block;
  color: #ffffff;
  border-radius: 4px;
  background-color: #232f3a;
  padding: 6px 9px 6px 9px;
  font-size: 0.85em;
  border: 1px solid #879baf;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.btn-export:focus {
  outline-color: #ffffff;
}
.btn-export:hover {
  background-color: white;
  color: #232f3a;
}
.disabled.btn-export {
  color: #879baf;
  background-color: #dde3e7;
  border-color: #dde3e7;
  cursor: auto;
}
.input-group input[type=checkbox] {
  display: inline-block;
  vertical-align: middle;
  margin: 0;
  margin-right: 13px;
  cursor: pointer;
  position: relative;
}
.input-group input[type=checkbox]:before {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  content: "";
  background-color: #ffffff;
  border: 1px solid #e1e6eb;
  display: inline-block;
  vertical-align: middle;
  width: 10px;
  height: 10px;
  padding: 2px;
  text-align: center;
  position: absolute;
  top: -25%;
}
.input-group input[type=checkbox]:checked:before {
  content: "\f00c";
  font-family: "FontAwesome";
  color: #232f3a;
}
.input-group input[type=checkbox]:focus {
  border: 1px solid #aee5ff;
  outline: none;
}
.cursor-pointer {
  cursor: pointer;
}
.edit-graphics-container::-webkit-scrollbar {
  height: 11px;
  overflow: visible;
  width: 11px;
  opacity: 1;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.edit-graphics-container::-webkit-scrollbar-button {
  height: 0;
  width: 0;
}
.edit-graphics-container::-webkit-scrollbar-corner {
  background: transparent;
}
.edit-graphics-container::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.edit-graphics-container::-webkit-scrollbar-thumb {
  background-color: #e3e6ea;
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
  min-height: 28px;
  padding: 100px 0 0;
  border-radius: 10px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.edit-graphics-container::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.edit-graphics-container::-webkit-scrollbar-track:hover {
  background-color: #eef2f6;
}
.edit-graphics-container::-webkit-scrollbar-track {
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
}
.input-group input[type=text] {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  border-radius: 4px;
  background-color: #ffffff;
  height: 30px;
  border: 1px solid #e1e6eb;
  line-height: 2.2em;
  font-size: 0.9em;
  padding: 0 15px;
  color: #232f3a;
}
.input-group input[type=text]:focus {
  border: 1px solid #aee5ff;
  outline: none;
}
.input-group input[type=text]::-webkit-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
.input-group input[type=text]:-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
.input-group input[type=text]::-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
.input-group input[type=text]:-ms-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
.input-group input.ng-invalid.ng-dirty[type=text],
.input-group input.ng-invalid.ng-touched[type=text] {
  border-color: #ef5350;
}
.btn-export {
  display: inline-block;
  color: #ffffff;
  border-radius: 4px;
  background-color: #232f3a;
  padding: 6px 9px 6px 9px;
  font-size: 0.85em;
  border: 1px solid #879baf;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.btn-export:focus {
  outline-color: #ffffff;
}
.btn-export:hover {
  background-color: white;
  color: #232f3a;
}
.disabled.btn-export {
  color: #879baf;
  background-color: #dde3e7;
  border-color: #dde3e7;
  cursor: auto;
}
.input-group input[type=checkbox] {
  display: inline-block;
  vertical-align: middle;
  margin: 0;
  margin-right: 13px;
  cursor: pointer;
  position: relative;
}
.input-group input[type=checkbox]:before {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  content: "";
  background-color: #ffffff;
  border: 1px solid #e1e6eb;
  display: inline-block;
  vertical-align: middle;
  width: 10px;
  height: 10px;
  padding: 2px;
  text-align: center;
  position: absolute;
  top: -25%;
}
.input-group input[type=checkbox]:checked:before {
  content: "\f00c";
  font-family: "FontAwesome";
  color: #232f3a;
}
.input-group input[type=checkbox]:focus {
  border: 1px solid #aee5ff;
  outline: none;
}
.input-group {
  font-size: 12px;
  letter-spacing: 0.1px;
  color: #232f3a;
  margin-bottom: 10px;
}
.input-group label {
  display: inline-block;
  margin-right: 13px;
  color: #7d8fa1;
}
.input-group input[type=text] {
  width: 305px;
  border-radius: 4px;
  vertical-align: middle;
}
.input-group:not(:last-child) {
  margin-bottom: 30px;
}
.input-group > * {
  vertical-align: middle;
}
.tasks .task {
  font-style: italic;
  letter-spacing: 0.1px;
  color: #232f3a;
  font-size: 12px;
}
.tasks .task-content {
  font-style: normal;
  margin-top: 14px;
}
:host {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.header-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 40px;
}
.header-text {
  font-family: "Open Sans";
  font-size: 16px;
  color: #232f3a;
  font-weight: bold;
}
.back-to-scheduler-container {
  display: flex;
  align-items: center;
}
.btn-export {
  height: 30px;
  width: 60px;
}
.dynamic-promo-container {
  display: flex;
  flex-grow: 1;
  justify-content: space-between;
}
.main-container {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 6.5vh 0 5vh 0;
}
.add-graphics-container,
.add-media-container {
  width: 23.5vw;
  height: 27.5vh;
  background-color: rgba(221, 227, 231, 0.25);
  align-self: center;
  margin-bottom: 6vh;
  cursor: pointer;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  padding: 10px;
  border: 1px solid #f1f3f4;
}
.edit-dynamic-promo-graphics-container {
  width: 23.5vw;
  height: 34.5vh;
  align-self: center;
  margin-bottom: 6vh;
  display: flex;
  flex-direction: column;
}
.edit-dp-graphics-header-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 9px;
}
.edit-dp-graphics-header-main {
  font-family: "Open Sans";
  font-size: 14px;
  color: #232f3a;
}
.edit-dp-graphics-header-secondary {
  color: #879baf;
  font-family: "Open Sans";
  font-size: 11px;
  text-decoration: underline;
  cursor: pointer;
  line-height: 25px;
}
.add-graphics-container-edit-mode {
  width: 23.5vw;
  display: flex;
  height: 31vh;
  flex-direction: column;
}
.add-media-container-edit-mode {
  width: 23.5vw;
  display: flex;
  height: 31vh;
  flex-direction: column;
}
.add-media-container {
  margin-bottom: 5vh;
}
.dynamic-promo-name-container {
  width: calc(23.5vw + 80px);
  height: 4vh;
  align-self: center;
  display: flex;
  margin-left: 80px;
  justify-content: space-between;
}
.oval {
  box-sizing: border-box;
  height: 8vh;
  border-radius: 100px;
  width: 8vh;
  align-self: center;
  border: 1px dashed #879baf;
  background-color: #ffffff;
  box-shadow: 2px 2px 3px 0 rgba(135, 155, 175, 0.38);
  margin-bottom: 2.5vh;
  display: flex;
  justify-content: center;
  margin-top: 5vh;
}
.dynamic-promo-add-text-main {
  font-family: "Open Sans";
  color: #232f3a;
  align-self: center;
  font-size: 14px;
  margin-bottom: 1vh;
}
.dynamic-promo-add-text-secondary {
  color: #879baf;
  font-family: "Open Sans";
  font-size: 12px;
  align-self: center;
}
.dynamic-promo-name-label {
  color: #879baf;
  font-family: "Open Sans";
  font-size: 12px;
  margin-right: 15px;
  line-height: 30px;
}
.dynamic-promo-name-input {
  flex-grow: 1;
  height: 30px;
  border: 1px solid #e1e6eb;
  border-radius: 4px;
  background-color: #ffffff;
  margin-right: 20px;
  padding: 2px 5px;
}
.top-buttons {
  width: 100%;
}
.rounded-btn,
.rounded-btn-prev {
  display: inline-block;
  background: #f1f3f4 no-repeat center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  cursor: pointer;
}
.rounded-btn-prev {
  background-image: url(/assets/icons/prev.svg);
  margin-right: 10px;
}
.back {
  line-height: 28px;
  float: right;
}
.add-graphics-icon,
.add-media-icon {
  align-self: center;
}
.add-media-icon {
  margin-left: 4px;
}
.edit-graphics-container {
  overflow-y: scroll;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  margin-bottom: 8vh;
  background-color: #f1f3f4;
  margin-left: 2vw;
}
.edit-mode-main-container {
  width: 23.5vw;
  flex-grow: 0;
  margin: 0 50px;
  padding-top: 0;
  padding-bottom: 0;
}
.edit-mode-header-container {
  border-bottom: none;
}
icn-edit-graphics-main {
  padding-top: 0;
  padding-left: 0;
  overflow-y: hidden;
}
.btn-export-big {
  width: 100px;
  text-align: center;
}
.dynamic-promo-edit-buttons-container {
  height: 4vh;
  background-color: white;
  display: flex;
  justify-content: flex-end;
  text-align: center;
  position: absolute;
  bottom: 15px;
  right: 30px;
}
video-container {
  position: relative !important;
  height: 100vh;
  margin-top: 10px;
  width: 100% !important;
}
.choose-media-clicked,
.choose-graphics-clicked {
  background-color: white;
}
.choose-media-clicked .add-graphics-inner-container,
.choose-graphics-clicked .add-graphics-inner-container {
  border: 1px dashed black;
}
.choose-media-clicked .add-media-icon,
.choose-graphics-clicked .add-media-icon {
  margin-left: 0px;
}
.add-graphics-inner-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
.float-left {
  float: left;
}
.float-right {
  float: right;
}
.promo-details-section {
  padding: 3%;
}
.promo-details-section .header {
  font-size: 12px;
  letter-spacing: 0.1px;
  color: #232f3a;
  font-weight: bold;
}
.promo-details-section .field {
  margin-top: 9px;
  margin-right: 15px;
  font-size: 12px;
  letter-spacing: 0.1px;
  color: #7d8fa1;
}
.promo-details-section .field span {
  margin-right: 14px;
}
.promo-details-section .field icn-number-input {
  display: inline-block;
}
.devider {
  height: 6px;
}
.edit-name-field {
  border-bottom: 1px solid #232f3a;
  margin-bottom: 31px;
}
.edit-name-field .label {
  float: left;
  width: 21.5vw;
  cursor: text;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: bold;
  line-height: 22px;
  height: 22px;
  border: 0;
}
.edit-name-field .edit-icon {
  float: right;
  height: 16px;
  width: 16px;
  background-color: red;
  background: url(/assets/icons/edit-icon@2x.png) no-repeat;
  background-size: cover;
}
/*# sourceMappingURL=dynamic-promo-create-edit.css.map */
